export * from '../../Core/SavePoint/savePoint.actions'

export const SETTINGS_SYNC_SAVEPOINT = 'SAVEPOINT_SETTINGS_SYNC_SAVEPOINT'
export const CHANGE_TURN_FINISH = 'SAVEPOINT_GAME_CHANGE_TURN_FINISH'
export const CHANGE_TURN_START = 'SAVEPOINT_GAME_CHANGE_TURN_START'
export const SET_ALERT_DATA = 'MAP_SET_ALERT_DATA'
export const REMOVE_ALERT_DATA = 'MAP_REMOVE_ALERT_DATA'
export const COMPLETE_SURVEY = 'SAVEPOINT_COMPLETE_SURVEY'
export const TOGGLE_SURVEY = 'SAVEPOINT_TOGGLE_SURVEY'

export const setAlertData = (data) => {
  return { type: SET_ALERT_DATA, data }
}
export const removeAlertData = () => {
  return { type: REMOVE_ALERT_DATA }
}
export const syncWithSettings = (wrappers) => {
  return { type: SETTINGS_SYNC_SAVEPOINT, data: wrappers }
}
export const finishTurnChange = () => {
  return { type: CHANGE_TURN_FINISH }
}
export const startTurnChange = () => {
  return { type: CHANGE_TURN_START }
}
export const toggleSurvey = () => {
  return { type: TOGGLE_SURVEY }
}
export const completeSurvey = () => {
  return { type: COMPLETE_SURVEY }
}
